import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Slider } from "@mui/material";
import api from "../utils/api";
import { toast, ToastContainer } from "react-toastify";
import SettingCategoriesTable from "../components/SettingCategoryTable";
import YoutubeRange from "../components/youtube/YoutubeRange";
import YoutubeToggle from "../components/youtube/YoutubeToggle";

const baseURL = process.env.REACT_APP_BASE_URL || "";

const YoutubeSetting = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState("all");

  const [minExplore, setMinExplore] = useState(1);
  const [maxExplore, setMaxExplore] = useState(10);
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [isLike, setIsLike] = useState(false);

  /* ================= FETCH ================= */
  const fetchYoutubeSettings = async (categoryId) => {
    try {
      const res = await api.get(
        `${baseURL}setting/youtube/${categoryId}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      setMinExplore(res.data.minYoutubeExploreRange ?? 1);
      setMaxExplore(res.data.maxYoutubeExploreRange ?? 10);
      setIsSubscribe(res.data.isYoutubeSubscribe ?? false);
      setIsLike(res.data.isYoutubeLike ?? false);
    } catch (err) {
      toast.error("Failed to load YouTube settings");
    }
  };

  /* ================= UPDATE ================= */
  const updateYoutubeSettings = async () => {
    if (minExplore > maxExplore) {
      toast.error("Min explore cannot be greater than Max explore");
      return;
    }

    try {
      await api.put(
        `${baseURL}setting/youtube/${selectedCategoryId}`,
        {
          minYoutubeExploreRange: minExplore,
          maxYoutubeExploreRange: maxExplore,
          isYoutubeSubscribe: isSubscribe,
          isYoutubeLike: isLike,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      toast.success("YouTube settings updated");
    } catch (err) {
      toast.error("Failed to update YouTube settings");
    }
  };

  /* ================= CATEGORY SELECT ================= */
  const handleCategorySelect = (categoryId) => {
    setSelectedCategoryId(categoryId);
    fetchYoutubeSettings(categoryId);
  };

  useEffect(() => {
    fetchYoutubeSettings("all");
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <ToastContainer position="top-center" autoClose={3000} />

      <Typography variant="h3" mb={3}>
        YouTube Settings
      </Typography>

      <Box display="flex">
        <SettingCategoriesTable onCategorySelect={handleCategorySelect} />

        <Box sx={{ flexGrow: 1, ml: 4 }}>
          <YoutubeRange
            min={minExplore}
            max={maxExplore}
            onMinChange={setMinExplore}
            onMaxChange={setMaxExplore}
          />

          <YoutubeToggle
            label="Subscribe to Channels"
            value={isSubscribe}
            onChange={setIsSubscribe}
          />

          <YoutubeToggle
            label="Like Videos"
            value={isLike}
            onChange={setIsLike}
          />

          <Button
            variant="contained"
            sx={{ mt: 3 }}
            onClick={updateYoutubeSettings}
          >
            Save YouTube Settings
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default YoutubeSetting;
